module.exports = __webpack_public_path__ + "img/flow1.101f2b0a.png";